import React from 'react';
import { APP_DOWNLOAD_BANNER } from '../../utils/RailsSEOConstants';
import { AppDownloadBannerPropsType } from '../types';
import AppDownload from './AppDownload/AppDownload';

const AppDownloadBanner = ({ language }: AppDownloadBannerPropsType) => {
  const isEngish = language === APP_DOWNLOAD_BANNER.english;

  const englishData = {
    text: APP_DOWNLOAD_BANNER.englishHeader,
    subtext: APP_DOWNLOAD_BANNER.englishSubHeader,
    ctaOpenAppText: APP_DOWNLOAD_BANNER.englishOpenApp,
    ctaDefaultText: APP_DOWNLOAD_BANNER.englishInstallApp,
    ctaDeeplink: APP_DOWNLOAD_BANNER.appLink
  };

  const hindiData = {
    text: APP_DOWNLOAD_BANNER.hindiHeader,
    subtext: APP_DOWNLOAD_BANNER.hindiSubHeader,
    ctaDefaultText: APP_DOWNLOAD_BANNER.hindiInstallApp,
    ctaDeeplink: APP_DOWNLOAD_BANNER.appLink
  };
  const data = isEngish ? englishData : hindiData;

  const omnitureData = {
    shownEvent: APP_DOWNLOAD_BANNER.omnitureShownEvent,
    clickEvent: APP_DOWNLOAD_BANNER.omnitureClickEvent
  };

  return (
    <div className="mobileShow">
      <AppDownload data={data} omnitureData={omnitureData} />
    </div>
  );
};

export default AppDownloadBanner;
